<template>
    <div>
        <Title :title="title" :path="formPath"/>

        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>

            <van-list v-model="isLoading"
                      finished-text="没有了~"
                      :immediate-check="false"
                      :finished="isFinished"
                      :error.sync="isError"
                      :error-text="match.list.length>0?'读取失败':''"
                      @load="onLoadMore">
                <match_mini :data="match"/>
            </van-list>
        </template>
    </div>
</template>

<script>
    import match_mini from './public/match_mini'
    import Title from './public/title'

    export default {
        name: "expert_view",
        components: {
            match_mini,
            Title
        },
        data() {
            return {
                title: '',
                formPath: '',
                match: {'type': 3, 'list': []},
                key: '',
                page: 1,
                isInit: true,
                isLoading: false,
                isLoadingError: false,
                isFinished: false,
                isError: false,
            }
        },
        activated() {
            let that = this
            this.isInit = true
            this.title = ''
            this.page = 1
            this.match.list = []
            if(that.$route.query.s) {
                that.key = that.$route.query.s
                that.getdata()
            }
        },
        methods: {
            onLoadMore(){
                // console.log(2)
                let that = this
                if(!that.isLoadingError)
                    that.page++
                that.getdata()
            },
            getdata(){
                let that = this
                that.$get(that.$api.search, {s: that.key, page: that.page})
                    .then(function (res) {
                        // console.log(res)
                        if(res.code === 1) {
                            let tmplist = res.data.list
                            if(tmplist.length > 0) {
                                tmplist.forEach(function (c) {
                                    c.same_num = 0
                                })
                                that.match.list = that.match.list.concat(tmplist)
                            }
                            else{
                                that.isFinished = true
                            }
                            that.title = res.data.match
                            that.isInit = false
                        }
                        else{
                            that.isError = true
                        }
                    })
                    .catch(function () {
                        that.isError = true
                        that.isLoadingError = true
                    })
                    .finally(function () {
                        that.isLoading = false
                    })
            },
        },
        computed: {

        },
        mounted() {

        },
        watch: {

        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path === '/' ?'/expert':''

            })
        }
    }
</script>

<style scoped>

</style>
